import { versionedHttpCollection } from "us.helper/http/collection";
import ServiceConfig from "service.config.js";
import { ICaseInformation } from "us.collection.case/reducers/CaseInformation/Interfaces";
import { CaseProfiles } from "us.collection.case/constants";

export default {
  Information: {
    get: async (caseId: number): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.getById(
            "arservice",
            "ars",
            `${caseId}/information`,
            ServiceConfig()[`arservice`]["ars.caseInformation"]
          );
          if (status === 200 || status === 404) {
            resolve(data);
          } else {
            reject(data);
          }
        } catch (error) {
          reject(error);
        }
      });
    },

    save: async (caseInfo: Partial<ICaseInformation>): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.post(
            "arservice",
            `ars/${caseInfo.caseId}/information`,
            caseInfo,
            ServiceConfig()[`arservice`]["ars.caseInformation"]
          );
          if (status === 201) {
            resolve(data);
          } else {
            reject(data);
          }
        } catch (error) {
          reject(error);
        }
      });
    },
  },

  ObsoleteInterest: {
    get: async (caseId: number): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.getById(
            "arservice",
            "ars",
            `${caseId}/interestoccurrences`,
            ServiceConfig()[`arservice`]["interestoccurrences.get"]
          );
          if (status === 200 || status === 404) {
            resolve(data);
          } else {
            reject(data);
          }
        } catch (error) {
          reject(error);
        }
      });
    },
    save: (params: any): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data } = await versionedHttpCollection.post(
            "arservice",
            `ars/${params.caseId}/interestoccurrences`,
            params,
            ServiceConfig()[`arservice`]["interestoccurrences.save"]
          );
          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
    delete: async (occurrenceId: number): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.delete(
            "arservice",
            `ars`,
            `${occurrenceId}/interestoccurrences`,
            {},
            ServiceConfig()[`arservice`]["interestoccurrences.delete"]
          );
          if (status === 202 || status === 404) {
            resolve(data);
          } else {
            reject(data);
          }
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  caseProfiles: {
    get: <P extends any>(params: P): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          let transactionProflies;
          let provisionProfiles;
          const { data, status } = await versionedHttpCollection.get(
            "bmdservice",
            `bmddatatypes`,
            {},
            "v1"
          );
          if (status === 200 && Array.isArray(data)) {
            const provisionProfileId =
              data.find((item: any) => item.name === CaseProfiles.PROVISION_PROFILE)?.id ??
              -1;

            const transactionProfileId =
              data.find((item: any) => item.name === CaseProfiles.TRANSACTION_PROFILE)
                ?.id ?? -1;

            transactionProflies = await versionedHttpCollection.getById(
              "bmdservice",
              "bmddatatypevalues",
              transactionProfileId,
              ServiceConfig()[`bmdservice`]["bmd.dataTypeValues"]
            );
            provisionProfiles = await versionedHttpCollection.getById(
              "bmdservice",
              "bmddatatypevalues",
              provisionProfileId,
              ServiceConfig()[`bmdservice`]["bmd.dataTypeValues"]
            );
          }

          resolve({ transactionProflies, provisionProfiles });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
